import { useQuery } from "@apollo/client";
import { USER_ARPS } from "constants/settings.constants";

import { FOLDERS_LIGHT } from "api/userArps";

import { ORG_FORECAST_ID } from "../constants/constants";

export interface UseOrganizationForecastsReturn {
  data;
  loading: boolean;
  error: Error | undefined;
  refetch: () => void;
}

export function useOrganizationForecasts(): UseOrganizationForecastsReturn {
  const {
    loading,
    data: foldersData,
    error,
    refetch
  } = useQuery(FOLDERS_LIGHT, {
    variables: {
      req: {
        projectId: ORG_FORECAST_ID,
        type: USER_ARPS
      }
    }
  });

  return {
    data: foldersData,
    loading: loading,
    error: error,
    refetch: refetch
  };
}
